import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import intance from "../utils/axios";

export const getListThuLaoNguoiDaiDien = async () => {
    var rs: Array<any> = []
    await intance.get(ApiPaths.thuLaoNguoiDaiDien.getList)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const getByIdThuLaoNguoiDaiDien = async (id: any) => {
    var rs: any;
    await intance.get(ApiPaths.thuLaoNguoiDaiDien.getById + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const getDsNguoiDaiDien = async (quy: number | null, nam: number, loai: number) => {
    var rs: any;    
    await intance.get(ApiPaths.thuLaoNguoiDaiDien.getDsNgDaiDien + "?quy=" + quy + "&nam=" + nam + "&loai=" + loai)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const saveThuLaoNguoiDaiDien = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.thuLaoNguoiDaiDien.save, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const trinhThuLaoNguoiDaiDien = async (id: any) => {
    var rs: any;
    await intance.post(ApiPaths.thuLaoNguoiDaiDien.trinh + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const duyetThuLaoNguoiDaiDien = async (id: any) => {
    var rs: any;
    await intance.post(ApiPaths.thuLaoNguoiDaiDien.duyet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const xoaThuLaoNguoiDaiDien = async (id: any) => {
    var rs: any;
    await intance.post(ApiPaths.thuLaoNguoiDaiDien.xoa + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};
export const xuatExcelThuLaoNDD = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.thuLaoNguoiDaiDien.xuatExcelThuLaoNguoiDaiDien + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};
